import { observer } from "mobx-react-lite"

import { ShowWhenTrue } from "@/components/conditionals"
import { useScaleApplication } from "@/domains/application/use-scale-application"
import { MinimalPoolStore } from "@/domains/minimal-pool"
import { MinimalPoolAddressesCard } from "@/domains/minimal-pool/components/minimal-pool-addresses-card"
import useResponsive from "@/hooks/use-responsive"

import { StrictApprovalWarning } from "../strict-approval-warning"

export const LiquidityPageLayout = observer(
  ({
    children,
    page,
    minimalPool,
  }: {
    children: React.ReactNode
    page: "add" | "stake" | "unstake" | "withdraw"
    minimalPool: MinimalPoolStore | null | undefined
  }) => {
    const scaleApp = useScaleApplication()
    const { isMobile, isTablet, isDesktop, width } = useResponsive()

    const isStrictMode = scaleApp?.Settings.approvalMode === "strict"

    if (isDesktop && width > 1400) {
      return (
        <div className="grid w-full grid-cols-1 gap-4 text-t100 xl:grid-cols-[minmax(auto,560px)_1fr]">
          <div className="flex w-full min-w-[320px] max-w-xl flex-col gap-4">{children}</div>
          <div className="flex max-w-xl flex-col gap-4">
            <ShowWhenTrue when={!!minimalPool}>
              <MinimalPoolAddressesCard minimalPool={minimalPool} />
              <ShowWhenTrue when={isStrictMode && page === "add"}>
                <StrictApprovalWarning token0={minimalPool?.token0} token1={minimalPool?.token1} />
              </ShowWhenTrue>
            </ShowWhenTrue>
          </div>
        </div>
      )
    }

    if (isDesktop) {
      return (
        <div className="grid grid-cols-2 gap-4">
          <div className="flex flex-col gap-4">{children}</div>
          <div className="flex flex-col gap-4">
            <ShowWhenTrue when={!!minimalPool}>
              <MinimalPoolAddressesCard minimalPool={minimalPool} />
              <ShowWhenTrue when={isStrictMode && page === "add"}>
                <StrictApprovalWarning token0={minimalPool?.token0} token1={minimalPool?.token1} />
              </ShowWhenTrue>
            </ShowWhenTrue>
          </div>
        </div>
      )
    }

    if (isMobile || isTablet) {
      return (
        <div className="w-full text-t100">
          <div className="space-y-4">
            {children}
            <ShowWhenTrue when={!!minimalPool}>
              <MinimalPoolAddressesCard minimalPool={minimalPool} />
              <ShowWhenTrue when={isStrictMode && page === "add"}>
                <StrictApprovalWarning token0={minimalPool?.token0} token1={minimalPool?.token1} />
              </ShowWhenTrue>
            </ShowWhenTrue>
          </div>
        </div>
      )
    }
  },
)
